import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import ExoticBirds from "../pages/exotic-birds/page";
import PetShopGrooming from "../pages/pet-shop-grooming/page";
import Contact from "../pages/contact/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <Services />,
  },
  {
    path: "/kus-egzotik",
    element: <ExoticBirds />,
  },
  {
    path: "/pet-shop-kuafor",
    element: <PetShopGrooming />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "/hakkimizda",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
